<div
  svcTestId="ap-form-checklist__section--content"
  class="col-span-full action-plan-checklist-tab"
  [formGroup]="checklistForm"
>
  <div formArrayName="checklistItems">
    @if (canModify) {
      <div class="action-plan-checklist-add-row">
        <button
          svcTestId="ap-form-checklist__btn--add-item"
          class="action-plan-checklist-add-btn flex items-center justify-center bg-primary rounded-full"
          type="button"
          mat-mini-fab
          id="action-plan-checklist-add"
          (click)="addChecklistItem()"
        >
          <mat-icon
            class="icon-size-4 text-white"
            svgIcon="mat_solid:add"
          ></mat-icon>
        </button>

        <span class="text-base text-default">{{ 'Adicionar' | transloco }}</span>
      </div>
    }

    <div
      svcTestId="ap-form-checklist__section--list"
      class="action-plan-checklist-list"
      cdkDropList
      [cdkDropListDisabled]="!canModify || checklistItemsControls.length <= 1"
      (cdkDropListDropped)="dropChecklist($event)"
    >
      @for (checklistGroup of checklistItemsControls; track $index; let i = $index) {
      <div
        [svcTestId]="'ap-form-checklist__section--item-' + i"
        class="action-plan-checklist-item"
        [formGroup]="checklistGroup"
        [class.completed]="checklistGroup.get('isCompleted')?.value"
        cdkDrag
        cdkDragBoundary=".action-plan-checklist-list"
        [cdkDragDisabled]="!canModify || checklistItemsControls.length <= 1"
      >
        <div
          class="action-plan-checklist-placeholder"
          *cdkDragPlaceholder
        ></div>

        @if (canModify) {
          <div class="action-plan-checklist-row">
            <mat-icon
              class="action-plan-checklist-drag-icon cursor-move text-primary -rotate-45"
              svgIcon="heroicons_outline:arrows-pointing-out"
              cdkDragHandle
            ></mat-icon>

            <mat-form-field class="w-full svc-mat-no-subscript svc-mat-dense action-plan-checklist-input">
              <input
                [svcTestId]="'ap-form-checklist__input--task-' + i"
                matInput
                class="text-base"
                [id]="'action-plan-checklist-item-' + i"
                formControlName="taskName"
                maxlength="50"
                (input)="onChecklistItemChanged()"
                (blur)="commitChecklistItem()"
              />
            </mat-form-field>

            @if (canToggleStatus) {
              <div class="action-plan-checklist-checkbox-wrapper">
                <mat-checkbox
                  [svcTestId]="'ap-form-checklist__checkbox--completed-' + i"
                  class="action-plan-checklist-checkbox"
                  color="primary"
                  formControlName="isCompleted"
                  (change)="toggleChecklistItemStatus(i)"
                ></mat-checkbox>
              </div>
            }

            <button
              [svcTestId]="'ap-form-checklist__icon-btn--remove-item-' + i"
              type="button"
              mat-icon-button
              class="action-plan-checklist-remove-btn"
              [disableRipple]="true"
              [id]="'action-plan-checklist-remove-' + i"
              (click)="removeChecklistItem(i)"
            >
              <mat-icon
                class="action-plan-checklist-trash-icon text-primary"
                svgIcon="heroicons_solid:trash"
              ></mat-icon>
            </button>
          </div>
        } @else {
          <div class="action-plan-checklist-row is-readonly">
            <span
              [svcTestId]="'ap-form-checklist__label--task-' + i"
              class="action-plan-checklist-text mx-2 text-base font-medium text-default"
            >
              {{ checklistGroup.get('taskName')?.value || '-' }}
            </span>
          </div>
        }
      </div>
      }
    </div>
  </div>
</div>
